
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import InitiativeMixin from "@/mixins/http/InitiativeMixin";
import { safeAsync } from "@/utils/AsyncUtil";
import VIcon from "@/components/VIcon.vue";
import { showErrorToast,showToast } from "@/utils/Toast";
import { Initiative } from "../../models";
import { currentUserStore } from "@/store/typed";

@Component({
  components: {
    VIcon,
  },
})
export default class InteractiveMap extends Mixins(InitiativeMixin) {
  @Prop({ required: true }) readonly initiative!: Initiative;
  @Prop({ required: true }) readonly title!: string[];
  @Prop({ required: true }) readonly icon!: string[];

  private publishable = this.initiative?.publishable || false;
  private alternativeTitle =
    this.initiative?.alternativeTitle || this.initiative?.name || null;
  private alternativeDescription =
    this.initiative?.alternativeDescription || null;


  async update() {
    const payload: Partial<Initiative> = {
      id: this.initiative.id,
      publishable: this.publishable,
      alternativeTitle: this.alternativeTitle || this.initiative.name,
      alternativeDescription: this.alternativeDescription,
    };

    const [data, errors] = await safeAsync(this.updateInitiative(payload));

    if (!errors) {
      showToast("Impostazioni salvate!");
    } else {
      showErrorToast("Sì è verificato un errore");
    }
  }

  get disabled() {
    return currentUserStore.user?.isOccUser || currentUserStore.user?.isConsipUser;
  }
}
